import type { SelectProps as AntdSelectProps } from 'antd/es/select'

export const ReadOnlyValueLabel = <ValueType,>({ options, value }: AntdSelectProps<ValueType>) => {
  const label =
    options?.find((option) => option.value === value)?.label ?? (value as React.ReactNode) ?? ''
  return (
    <span
      title={typeof label === 'string' ? label : undefined}
      className='truncate text-main-foreground-primary text-body-default'
    >
      {label}
    </span>
  )
}
